import { render, staticRenderFns } from "./browserDeprecationWarning.vue?vue&type=template&id=fec98ec6&scoped=true&"
import script from "./browserDeprecationWarning.vue?vue&type=script&lang=js&"
export * from "./browserDeprecationWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec98ec6",
  null
  
)

export default component.exports